<template>
  <Billing />
</template>

<script setup>
import Billing from "@/argon/views/Billing.vue";
</script>
